var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpecializationInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "book-open-reader-solid",
    d: "M20.312,12.187A12.187,12.187,0,1,1,32.5,24.375,12.187,12.187,0,0,1,20.312,12.187Zm10.156,19.3V65l-6.145-3.072a24.419,24.419,0,0,0-8.48-2.45L3.656,58.259A4.074,4.074,0,0,1,0,54.209V28.437a4.058,4.058,0,0,1,4.063-4.062H7.909A39.391,39.391,0,0,1,30.469,31.484ZM34.531,65V31.484a39.391,39.391,0,0,1,22.56-7.109h3.847A4.058,4.058,0,0,1,65,28.437V54.209a4.062,4.062,0,0,1-3.656,4.037L49.156,59.465a24.5,24.5,0,0,0-8.48,2.45Z",
    fill: "#f5f7f9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecializationInfoIcon);
export default __webpack_public_path__ + "static/media/specialization-info-icon.5f1272ee3dfad4dacfafac6ab0ca2841.svg";
export { ForwardRef as ReactComponent };